/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {AssetType} from '@ion/core/src/types/entities';
import {AssetTypeIcon} from '@ion/dls/src/icons/AssetTypeIcon';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {IconSize} from '@ion/dls/src/types/types';

export interface AssetTypeCellType {
  data: {
    assetType: AssetType
  };
}

const useStyles = makeStyles(theme => ({
  assetTypeCell : {
    display        : 'flex',
    justifyContent : 'flex-start',
    alignItems     : 'center',
    height         : '100%'
  },
  assetTypeCellIcon : {
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    marginRight    : '6px'
  }
}));

export const AssetTypeCell = ({data}: AssetTypeCellType) => {
  const classes = useStyles();
  return (
    data?.assetType ? (
      <div className={classes.assetTypeCell}>
        <div className={classes.assetTypeCellIcon}>
          <AssetTypeIcon assetType={AssetType[data?.assetType || 'Vehicle']}
            size={IconSize.small}
            color={dlsColor('grey3')} />
        </div>
        <span>{data.assetType}</span>
      </div>
    ) : null
  );
};

export default AssetTypeCell;
